import React, {FC} from 'react';

import {sendDesktopAnalyticsEvent} from '@optimaxdev/analytics/desktop/lib/sendAnalyticsEvent/index';
import {CtaButton} from '@optimaxdev/design-system';
import {Icon, VenmoWhite as VenmoIcon} from '@optimaxdev/icons';
import classNames from 'classnames';
import {connect} from 'react-redux';

import {useFeature} from 'components/feature';
import {CHECKOUT_PAYMENT_STEP} from 'constants/analytics/events/checkout';
import {PaymentStepAgreement} from 'desktop/pages/checkout/components/paymentStepAgreement/paymentStepAgreement';
import {getVenmoMessageError} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentMethodSave/paymentMethodSave';
import {ApplicationStoreType} from 'desktop/store';

import s from './paymentVenmoButton.scss';

export type PropsType = {
    onClick: () => void;
    errorMessage?: string | boolean;
    venmoErrorMessage?: string | null;
    isPaymentAuthorized: boolean;
    onSubmit?: () => void;
};

/**
 * Payment Venmo Button for checkout
 */
export const PaymentVenmoButton: FC<PropsType> = ({
    errorMessage,
    isPaymentAuthorized,
    onClick,
    onSubmit,
    venmoErrorMessage,
}) => {
    const isFacelift = useFeature('dCheckoutFacelift');

    const clickHandler = () => {
        sendDesktopAnalyticsEvent(
            CHECKOUT_PAYMENT_STEP,
            {
                message: 'CTA - Venmo',
                method: 'Payment',
            },
            true,
        );
        onClick();
    };

    return (
        <>
            <p
                className={classNames(s.text, s.marginBottom, {
                    [s.marginBottomFacelift]: isFacelift,
                })}
            >
                {!isPaymentAuthorized &&
                    'Click the button to be redirected to Venmo & complete your purchase.'}
                <PaymentStepAgreement
                    className={classNames(s.text, {[s.textFacelift]: isFacelift})}
                />
            </p>

            <div className={s.btnWrapper}>
                {isPaymentAuthorized ? (
                    <CtaButton
                        ariaLabel="Place Order"
                        onClick={onSubmit}
                        size="medium"
                        type="button"
                    >
                        Place Order
                    </CtaButton>
                ) : (
                    <button
                        aria-label="Pay with Venmo"
                        className={s.button}
                        onClick={clickHandler}
                        type="button"
                    >
                        <span className={s.buttonText}>Pay with</span>
                        <Icon icon={VenmoIcon} />
                    </button>
                )}
            </div>
            <p className={classNames(s.text, s.errorMessage)}>
                {errorMessage || venmoErrorMessage}
            </p>
        </>
    );
};

/**
 * Map state to props
 * @param {ApplicationStoreType} store - redux store
 * @returns {PropsType} props
 */
const mapStateToProps = (store: ApplicationStoreType) => ({
    errorMessage: getVenmoMessageError(store),
});

export const PaymentVenmoButtonConnected = connect(mapStateToProps)(PaymentVenmoButton);
